import type { ListExportFmt } from '@shared/components/ui/ListOperationsDropdown';
import type { GlobalToastOptions } from '@shared/components/Toast/ToastProvider';

type ShowToast = (opts: GlobalToastOptions) => void;

let listExportShowToast: ShowToast | null = null;

/** Wired from `<ToastProvider>` so export stubs can toast without React hooks. */
export function registerListExportToast(fn: ShowToast | null): void {
  listExportShowToast = fn;
}

export function listExportNotImplemented(entityLabel: string, fmt: ListExportFmt, scope: 'selection' | 'all') {
  const body = `Export (${fmt}, ${scope}) for ${entityLabel} is not wired yet.`;
  if (listExportShowToast) {
    listExportShowToast({ title: 'Export not available', body, variant: 'info' });
  } else {
    // eslint-disable-next-line no-console
    console.warn(body);
  }
}
